import { memo, useRef, useState } from 'react'
import { Link } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { Logo } from 'src/shared/components/icons/logos/logo'
import SimpleSidebar from 'src/shared/features/home/components/simple-sidebar'
import { HamburgerIcon } from 'src/shared/features/home/icons/hamburger'
import { useIsMobile } from 'src/shared/hooks/use-mobile'
import { cn } from 'src/shared/utils/cn'

import HeaderAuthIndicator from './header-auth-indicator'
import type { SearchbarHandle } from './search-bar'
import MarketplaceSearchbar from './search-bar'

const MarketplaceHeader = ({ profile = false }: { profile?: boolean }) => {
  const isMobile = useIsMobile()
  const searchbarRef = useRef<SearchbarHandle>(null)
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const onPressLogo = () => {
    searchbarRef.current?.resetForm()
  }

  return (
    <header
      className="fixed top-0 z-50 flex h-[70px] w-full items-center justify-between bg-white p-4 md:h-[100px] md:px-8"
      style={{
        borderBottom: '0.5px solid rgba(216, 216, 214, 0.75)',
        boxShadow: '0px 4px 12px 0px rgba(27, 48, 41, 0.03)',
      }}
    >
      <div
        className={cn(
          'mx-auto flex size-full max-w-[calc(2400px-4rem)] items-center justify-between',
          !profile ? 'max-w-[calc(2400px-4rem)]' : 'max-w-[calc(1400px-6rem)]',
        )}
      >
        <div className="flex flex-row items-center gap-4">
          {isMobile && (
            <button onClick={() => setSidebarOpen(true)}>
              <HamburgerIcon className="size-5 text-primary sm:size-6" />
            </button>
          )}
          <div className={cn(isMobile && 'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2')}>
            <Link
              to={paths.root.getHref()}
              className="flex h-full flex-col items-start justify-center gap-2"
              onClick={onPressLogo}
            >
              <Logo className="h-[28px] w-[120px] md:h-[30px] md:w-[155px]" />
            </Link>
          </div>
        </div>
        {!isMobile && <MarketplaceSearchbar ref={searchbarRef} />}
        <HeaderAuthIndicator />
      </div>
      <SimpleSidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
    </header>
  )
}

const MemoizedMarketplaceHeader = memo(MarketplaceHeader)

export default MemoizedMarketplaceHeader
